module.exports = __webpack_public_path__ + "static/media/spinebuzz-3.bdeb8fa3.jpg";